export default {
    zh: {
        groupName: "组名",
        category: "分类",
        leaderName: "组长"
    },
    en:{
        groupName: "Group Name",
        category: "Category",
        leaderName: "Leader Name"
    }
}
